import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/PrimaryButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import {
  CheckboxInputField,
  SelectField,
  TextInputField,
} from '../../../components/FormCom/FormField';
import { ModalContentWrapper } from '../../../components/Modal/ModalContentWrapper';
import useListState from '../../../hooks/warehouse/useListState';
import useWareHouse from '../../../hooks/warehouse/useWareHouse';
import {
  IWarehouseRequest,
  WarehouseDataType,
  WarehouseInitialValues,
  WarehouseSchema,
} from '../../../models/warehouse/warehouse.model';
import { getStateCode } from '../../../utils/utils';

const CreateWarehouseModal = () => {
  const { createWarehouse, loading } = useWareHouse();
  const { listOfState } = useListState();

  const onSubmit = (values: WarehouseDataType, actions: any) => {
    const data: IWarehouseRequest = {
      ...values,
      contactPersonPhoneNo: '234' + values.contactPersonPhoneNo.slice(1),
      stateCode: getStateCode(listOfState, values.stateCode),
    };

    createWarehouse(data);

    // if (resetInputFields) {
    actions.resetForm(WarehouseInitialValues);
    // }
  };

  return (
    <ModalContentWrapper title={'Create Warehouse'} width={'28rem'}>
      <Container>
        <FormComponent
          initialValues={WarehouseInitialValues}
          schema={WarehouseSchema}
          onSubmit={onSubmit}
        >
          <TextInputField
            label="Name"
            name="name"
            type="text"
            placeholder="Name"
            className="full"
          />
          <TextInputField
            label="Warehouse No"
            name="warehouseCode"
            type="text"
            placeholder="Warehouse No"
            className="full"
          />

          {/* <TextInputField
            label="Warehouse City"
            name="warehouseCity"
            type="text"
            placeholder="Warehouse City"
            className="full"
          /> */}

          <SelectField label="Warehouse City" name="stateCode">
            <option
              disabled
              value=""
              className="select-with-disabled-selected-option"
            >
              {'Select City'}
            </option>
            {listOfState &&
              listOfState.map((data: any, index: number) => (
                <option key={index}>{data.name}</option>
              ))}
          </SelectField>

          <TextInputField
            label="Contact Person Name"
            name="contactPersonName"
            type="text"
            placeholder="Contact Person Name"
            className="full"
          />
          <TextInputField
            label="Warehouse Address"
            name="warehouseAddress"
            type="text"
            placeholder="Warehouse Address"
            className="full"
          />

          <TextInputField
            label="Contact Person Phone No"
            name="contactPersonPhoneNo"
            type="text"
            placeholder="Contact Person Phone No"
            className="full"
          />

          <TextInputField
            label="Contact Person Email"
            name="contactPersonEmail"
            type="email"
            placeholder="Contact Person Email"
            className="full"
          />

          <TextInputField
            label="Type"
            name="type"
            type="text"
            placeholder="Type"
            className="full"
          />

          <CheckboxInputField
            label="Status"
            name="status"
            type="checkbox"
            placeholder="Status"
            className="full"
          />

          <TextInputField
            label="Rack Count"
            name="rackCount"
            type="number"
            placeholder="Rack Count"
            className="full"
          />

          <FormSubmitButton
            type="submit"
            showIcon={loading}
            className="placeLeft"
          >
            Create Warehouse
          </FormSubmitButton>
        </FormComponent>
      </Container>
    </ModalContentWrapper>
  );
};

export default CreateWarehouseModal;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
